// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { noop } from 'lodash/fp';

import { findDeviceTypeMessage } from '~/core/translations/devices';
import { deviceTypeToIcon } from '~/core/utils/svg-icons';
import DeviceListItem from '../item';
import { DeviceIconWrapper, StyledSVGIcon } from '../item/styles';
import {
    DropDownIcon,
    FlipIcon,
    GroupCount,
    GroupExpand,
    GroupItemList,
    GroupName,
    GroupWrapper,
    ItemContainer
} from './styles';

import type { DeviceModel, DeviceType, Region } from '~/core/types/devices';

type Props = {
    devices: Array<*>,
    localeSuffix?: Region,
    model?: DeviceModel,
    type: DeviceType,
    manufacturer?: string,
    identifyDevice: noop,
    isNano1: boolean
};

type State = {
    showGroupItems: boolean
};

export default class DeviceListGroup extends React.Component<Props, State> {
    state = {
        showGroupItems: false
    };

    toggleShowGroupItems = () => this.setState({ showGroupItems: !this.state.showGroupItems });

    render() {
        const { devices, localeSuffix, model, type, manufacturer, identifyDevice, isNano1 } = this.props;

        return (
            <div>
                <GroupWrapper onClick={this.toggleShowGroupItems}>
                    <DeviceIconWrapper>
                        <StyledSVGIcon type={deviceTypeToIcon({ model, type, localeSuffix })} />
                    </DeviceIconWrapper>
                    <ItemContainer>
                        <GroupName>
                            <FormattedMessage
                                {...findDeviceTypeMessage(type, manufacturer, model)}
                                values={{ amount: 2 }}
                            />
                        </GroupName>
                        <GroupCount>x{devices.length}</GroupCount>
                        <GroupExpand>
                            <FlipIcon isExpanded={this.state.showGroupItems}>
                                <DropDownIcon />
                            </FlipIcon>
                        </GroupExpand>
                    </ItemContainer>
                </GroupWrapper>
                <GroupItemList
                    component="ul"
                    enter={{
                        animation: { 'max-height': '10rem', rotateX: 0 },
                        duration: 300
                    }}
                    leave={{
                        animation: { 'max-height': 0, rotateX: '90deg' },
                        duration: 300
                    }}
                >
                    {this.state.showGroupItems &&
                        devices.map(({ id, field, props }) => (
                            <li key={type + '-group-' + id}>
                                <DeviceListItem
                                    capabilities={props.capabilities}
                                    field={field}
                                    id={id}
                                    identifyDevice={identifyDevice}
                                    isNano1={isNano1}
                                    localeSuffix={localeSuffix}
                                    manufacturer={props && props.manufacturer}
                                    model={props && props.model}
                                    online={props && props.online}
                                    type={type}
                                />
                            </li>
                        ))}
                </GroupItemList>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/device-list/group/index.js